<template>
  <div class="skill-page">
    <div class="page-header">
      <h2>轨迹绘制</h2>
    </div>

    <el-row :gutter="20">
      <el-col :span="24">
        <CodeCard
          title="高德地图轨迹绘制"
          description="基于高德地图 JS API v2.0，支持开始/结束绘制、地图点击落点、轨迹线实时渲染、起终点与途经点标记、总里程计算，以及 JSON / CSV / WKT 三种轨迹数据格式的查看、复制与下载。"
          :codeContent="trackDrawCode"
        >
          <TrackDraw />
        </CodeCard>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CodeCard from '@/components/CodeCard.vue'
import TrackDraw from '@/components/map/TrackDraw.vue'

export default {
  name: 'PcMapTrackDraw',
  components: {
    CodeCard,
    TrackDraw
  },
  data() {
    return {
      trackDrawCode: `<template>
  <div class="track-draw">
    <div ref="mapContainer" class="map-stage"></div>
    <el-button @click="drawing = !drawing">{{ drawing ? '结束绘制' : '开始绘制' }}</el-button>
    <el-input type="textarea" :rows="10" readonly :value="trackDataText" />
    <el-button @click="copyTrackData">复制数据</el-button>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'

export default {
  data() {
    return {
      AMap: null,
      map: null,
      layer: null,
      drawing: false,
      points: []
    }
  },
  computed: {
    // 轨迹数据文本：绘制完成后展示并可复制
    trackDataText() {
      return JSON.stringify({
        type: 'Polyline',
        coordinateSystem: 'GCJ02',
        pointCount: this.points.length,
        points: this.points.map((p, i) => ({ index: i + 1, lng: p.lng, lat: p.lat }))
      }, null, 2)
    }
  },
  async mounted() {
    const AMap = await AMapLoader.load({
      key: 'YOUR_AMAP_KEY',
      version: '2.0',
      plugins: ['AMap.Scale', 'AMap.ToolBar']
    })
    this.AMap = AMap
    this.map = new AMap.Map(this.$refs.mapContainer, {
      zoom: 13,
      center: [116.397428, 39.90923],
      doubleClickZoom: false
    })
    this.layer = new AMap.OverlayGroup()
    this.map.add(this.layer)
    this.map.on('click', this.handleMapClick)
    this.map.on('dblclick', () => { this.drawing = false })
  },
  methods: {
    // 绘制中：地图点击追加轨迹点
    handleMapClick(event) {
      if (!this.drawing) return
      this.points.push({
        lng: Number(event.lnglat.getLng().toFixed(6)),
        lat: Number(event.lnglat.getLat().toFixed(6))
      })
      this.renderTrack()
    },
    // 重新渲染轨迹线 + 点标记
    renderTrack() {
      this.layer.clearOverlays()
      const path = this.points.map(p => [p.lng, p.lat])
      if (path.length >= 2) {
        this.layer.addOverlay(new this.AMap.Polyline({
          path, showDir: true, strokeColor: '#3478f6', strokeWeight: 6
        }))
      }
      path.forEach((position, index) => {
        this.layer.addOverlay(new this.AMap.Marker({ position }))
      })
    },
    // 复制轨迹数据（clipboard + execCommand 双兜底）
    async copyTrackData() {
      const text = this.trackDataText
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text)
        return
      }
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.top = '-9999px'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
    }
  }
}
<\/script>`
    }
  }
}
</script>

<style scoped>
.skill-page {
  /* 覆盖全局 .skill-page：撑满内容区，内边距由内容区统一提供 */
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  padding: 0;
  background-color: transparent;
}

.page-header {
  margin-bottom: 30px;
  text-align: center;
}

.page-header h2 {
  margin-bottom: 10px;
  color: #303133;
}

.page-header p {
  color: #606266;
  font-size: 14px;
}
</style>
